import { useEffect, useState } from 'react';

/**
 * Just return true if JS loaded. Used to prevent form submits on JS disabled pages
 */
export default function useJSLoaded() {
  const [loaded, set] = useState(false);
  useEffect(() => {
    set(true);
  }, []);

  return loaded;
}
